//components
import ActionButtonIcon from "../../Button/ActionButtonIcon";
//icons
import { X, MagnifyingGlass } from "@phosphor-icons/react";
import { MdOutlineSearch, MdOutlineClose } from "react-icons/md";
import React, { useState } from 'react';
import * as S from './styles';

interface IFilterProps {
    title: string;
    subtitle: string;
    onDataChange: any;
}

export default function TitleHeaderCashFlow(
    {
        title,
        subtitle,
        onDataChange,
    }: IFilterProps
) {
    const [selectedDate, setSelectedDate] = useState('');
    const [buttonClearDate, setButtonClearDate] = useState(false);

    //Limpar Campo Data
    const handleClearDate = () => {
        setSelectedDate('');
        onDataChange('');
        setButtonClearDate(false);
    }

    //Pesquisar Por Data
    const handleData = () => {
        if (selectedDate) {
            const [year, month, day] = selectedDate.split('-'); // Extrai dia, mês e ano do input
            onDataChange({ day, month, year }); // Define o filtro de data
            setButtonClearDate(true);
        } else {
            alert('Digite uma data válida!')
        }
    }


    return (
        <S.Container>
            <S.Title>
                <S.H4>{title}</S.H4>
                <S.H6>{subtitle}</S.H6>
            </S.Title>

            <S.ContentFilter>
                <S.ContentInputSearch>
                    <S.Input
                        type='date'
                        value={selectedDate}
                        onChange={(e: any) => setSelectedDate(e.target.value)}
                    />

                    <S.ContentButton>
                        <div>
                            {
                                buttonClearDate &&
                                <S.ButtonClose
                                    onClick={handleClearDate}
                                >
                                    <X size={18} weight="fill" />
                                </S.ButtonClose>
                            }
                        </div>

                        <ActionButtonIcon
                            icon={<MagnifyingGlass size={18} />}
                            actionButon={handleData}
                        />
                    </S.ContentButton>
                </S.ContentInputSearch>
            </S.ContentFilter>
        </S.Container>
    );
}